import { render, staticRenderFns } from "./PersonNewsList.vue?vue&type=template&id=afe33740&scoped=true"
import script from "./PersonNewsList.vue?vue&type=script&lang=js"
export * from "./PersonNewsList.vue?vue&type=script&lang=js"
import style0 from "./PersonNewsList.vue?vue&type=style&index=0&id=afe33740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe33740",
  null
  
)

export default component.exports